const updatePaymentArray = (transactions, isAssign, unItemiziseDistributions, shareDistribution, originationDistribution, responsibleDistribution, referralDistribution, expensesDistribution) => {
  let data = [];
  let output = [];
  const payment = transactions.filter(transaction => transaction.checked);
  if (!isAssign) {
    payment.forEach(p => {
      data.push({
        paymentId: p.id,
        distributionId: unItemiziseDistributions,
        share: true,
        origination: true,
        responsible: true,
        referral: true,
        expenses: true
      });
    });
  } else {
    payment.forEach(p => {
      const share = {
        paymentId: p.id
      };
      if (shareDistribution.share) {
        share.share = true;
        share.distributionId = shareDistribution.distributionId;
      }
      const origination = {
        paymentId: p.id
      };
      if (originationDistribution.origination) {
        origination.origination = true;
        origination.distributionId = originationDistribution.distributionId;
      }
      const responsible = {
        paymentId: p.id
      };
      if (responsibleDistribution.responsible) {
        responsible.responsible = true;
        responsible.distributionId = responsibleDistribution.distributionId;
      }
      const referral = {
        paymentId: p.id
      };
      if (referralDistribution.referral) {
        referral.referral = true;
        referral.distributionId = referralDistribution.distributionId;
      }
      const expenses = {
        paymentId: p.id
      };
      if (expensesDistribution.expenses) {
        expenses.expenses = true;
        expenses.distributionId = expensesDistribution.distributionId;
      }
      output.push(share, origination, responsible, referral, expenses);
      output = output.filter(dist => dist.distributionId);
      const distributionPaymentsArray = Object.values(output.reduce((accu, {
        distributionId,
        ...rest
      }) => {
        if (!accu[distributionId]) accu[distributionId] = {};
        accu[distributionId] = {
          distributionId,
          ...accu[distributionId],
          ...rest
        };
        return accu;
      }, {}));
      distributionPaymentsArray.forEach(dp => {
        data.push(dp);
      });
    });
  }
  return data;
};
export default updatePaymentArray;